import { Text, Button } from "../../../Components/Index";

export function LoadingState() {
  return (
    <div className="latest-services-state">
      <div className="latest-services-spinner" aria-hidden />
      <Text position="center" color="gray">
        در حال بارگذاری سرویس‌ها...
      </Text>
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div className="latest-services-state latest-services-state--error">
      <Text position="center" color="red">
        {message}
      </Text>
      <Button size="mini" color="dark" onClick={onRetry}>
        تلاش مجدد
      </Button>
    </div>
  );
}

export function EmptyState() {
  return (
    <div className="latest-services-state">
      <div className="latest-services-empty-icon" aria-hidden>
        <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="#c4c4c4" strokeWidth="1.6">
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="M7 10h10M7 14h6" strokeLinecap="round" />
        </svg>
      </div>
      <Text position="center" color="gray" FontSize="md">
        هیچ سرویس ثبت شده‌ای برای این خودرو یافت نشد
      </Text>
    </div>
  );
}

export function ListTitle() {
  return (
    <div className="latest-services-header">
      <Text FontWight="Bold" FontSize="lg" position="right" className="latest-services-title">
        لیست سرویس‌های انجام شده
      </Text>
    </div>
  );
}
